<script lang="ts">
    export let companyId: string;

    interface Job {
        id: string;
        title: string;
        description: string;
        locations: string[];
        webUrl: string;
        slug: string;
    }

    let jobs: Job[] = [];
    let loading = true;
    let error: string | null = null;
    let currentPage = 0;
    let hasNext = false;
    let totalJobs = 0;

    async function loadJobs(reset = false) {
        if (reset) {
            currentPage = 0;
            jobs = [];
        }

        loading = true;
        error = null;

        try {
            const params = new URLSearchParams({
                page: currentPage.toString(),
                size: '10',
                sort: 'lastRefreshedAt',
                order: 'DESC'
            });

            const res = await fetch(`/api/companies/${companyId}/jobs?${params}`);
            if (!res.ok) throw new Error('Failed to load jobs');

            const data = await res.json();

            if (reset) {
                jobs = data.jobs;
            } else {
                jobs = [...jobs, ...data.jobs];
            }

            hasNext = data.hasNext;
            totalJobs = data.totalElements;
        } catch (err) {
            error = err instanceof Error ? err.message : 'Unknown error';
        } finally {
            loading = false;
        }
    }

    function loadMore() {
        currentPage++;
        loadJobs();
    }

    loadJobs();
</script>

{#if loading && jobs.length === 0}
    <p class="muted">loading...</p>
{:else if error}
    <p class="flash err">{error}</p>
{:else if jobs.length === 0}
    <p class="muted" style="font-style: italic; padding: 14px 0;">no open positions at this time.</p>
{:else}
    <p class="meta">{totalJobs} open {totalJobs === 1 ? 'position' : 'positions'}</p>

    <ul class="jobs">
        {#each jobs as job}
            <li>
                <a href="/jobs/{job.slug}">{job.title}</a>
                {#if job.locations && job.locations.length}
                    <div class="job-meta">
                        {#each job.locations as loc}
                            <span class="tag">{loc}</span>
                        {/each}
                    </div>
                {/if}
            </li>
        {/each}
    </ul>

    {#if hasNext}
        <p class="load-more-wrap">
            <button class="load-more" on:click={loadMore} disabled={loading}>
                {loading ? 'loading...' : 'load more jobs'}
            </button>
        </p>
    {/if}
{/if}
